module.exports = __webpack_public_path__ + "static/media/transiluminator-switch-on.9b45afd8.svg";